export const mobile = '@media (max-width: 767px)';
export const tablet = '@media (max-width: 991px)';
export const desktop = '@media (min-width: 992px)';
